<div class="dialog-container">
  <div class="dialog-header">
    <h2 mat-dialog-title>{{ data.title }}</h2>
    <button mat-icon-button aria-label="Close" (click)="onCancel()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content>
    <p [innerHTML]="data.message"></p>
  </mat-dialog-content>

  <mat-dialog-actions class="actions" [align]="data.actions?.align || 'end'">
    <button mat-raised-button color="{{data.confirm?.color || 'primary'}}" (click)="onConfirm()">{{ data.confirm?.text || 'Confirm' }}</button>
    <button mat-stroked-button color="{{data.cancel?.color || ''}}" (click)="onCancel()">{{ data.cancel?.text || 'Cancel' }}</button>
  </mat-dialog-actions>
</div>